import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDoctorContext } from "../../../Navigation/context/DoctorContext";
import style from "./bottom_nav.module.css";

interface BottomNavProps {
  notifBadge?: number;
}

const NAV_ITEMS = [
  { to: "/dashboard", icon: "home", label: "Home" },
  { to: "/history", icon: "history", label: "History" },
  { to: "/notifications", icon: "notifications", label: "Alerts" },
  { to: "/profile", icon: "person", label: "Profile" },
];

export const BottomNav: React.FC<BottomNavProps> = ({ notifBadge }) => {
  const { pathname } = useLocation();
  const { readNotificationIds, incomingRequest, todayConsultationCount } = useDoctorContext();
  const bellRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!incomingRequest || !bellRef.current) return;
    const el = bellRef.current;
    el.classList.remove("bellShake");
    void el.offsetWidth;
    el.classList.add("bellShake");
    const timer = setTimeout(() => el.classList.remove("bellShake"), 700);
    return () => clearTimeout(timer);
  }, [incomingRequest]);

  const unreadCount = Math.max(0, todayConsultationCount - readNotificationIds.filter((id: string) => id).length);
  const effectiveNotifBadge = notifBadge !== undefined ? notifBadge : incomingRequest ? 1 : 0;
  const badge = effectiveNotifBadge + unreadCount;

  return (
    <div className={style.bottomNav}>
      {NAV_ITEMS.map(({ to, icon, label }) => {
        const isActive = pathname === to;
        return (
          <Link key={to} to={to} className={`${style.navItem} ${isActive ? style.active : ""}`}>
            <div className={style.navIconBg}>
              {label === "Alerts" ? (
                <span ref={bellRef} className="material-icons-round">{icon}</span>
              ) : (
                <span className="material-icons-round">{icon}</span>
              )}
              {label === "Alerts" && badge > 0 && (
                <span className={style.navBadge}>{badge > 9 ? "9+" : badge}</span>
              )}
            </div>
            {label}
          </Link>
        );
      })}
    </div>
  );
};
